import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../common/Button/Button';
import styles from './CourseCard.module.css';

/**
 * Individual course card used in the Home courses grid.
 * Accepts a `course` object matching the shape defined in data/courses.js.
 */
function CourseCard({ course }) {
  const navigate = useNavigate();
  const { imgClass, emoji, tag, tagClass, title, desc, features, page } = course;

  function handleRegister() {
    navigate(`/${page}`);
    setTimeout(() => {
      const testId = page === 'toeic' ? 'toeic-test' : 'jlpt-test';
      const el = document.getElementById(testId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  }

  function handleViewDetails() {
    navigate(`/${page}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <article className={styles.card}>
      <div className={[styles.cardImg, styles[imgClass]].join(' ')} aria-hidden="true">
        <span>{emoji}</span>
      </div>
      <div className={styles.body}>
        <span className={[styles.tag, styles[tagClass]].join(' ')}>{tag}</span>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.desc}>{desc}</p>
        <ul className={styles.features} aria-label="Nội dung khoá học">
          {features.map((f, i) => (
            <li key={i}>{f}</li>
          ))}
        </ul>
        <div className={styles.btns}>
          <Button variant="sm-rose" onClick={handleRegister}>
            Đăng ký học thử
          </Button>
          <Button variant="sm-outline" onClick={handleViewDetails}>
            Xem chi tiết
          </Button>
        </div>
      </div>
    </article>
  );
}

export default CourseCard;
